import { Label, Popup } from 'semantic-ui-react';
import { STATUSES } from 'constants/constants';
import DateColumn from 'components/DateColumn/DateColumn';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';

export const getColumns = (renderActions = () => {}) => [
  {
    Header: 'Referencia',
    disableSortBy: true,
    accessor: 'reference',
    width: 150,
  },
  {
    Header: 'Almacén',
    disableSortBy: true,
    accessor: 'warehouse',
    width: 120,
    textAlign: 'center',
    Cell: ({ value }) => value?.warehouse || '',
  },
  {
    Header: 'Agencia',
    disableSortBy: true,
    accessor: 'agency',
    width: 50,
    textAlign: 'center',
    Cell: ({ value }) => {
      return <CarrierLogo code={value?.agency_code} /> || '';
    },
  },
  {
    Header: 'Creación',
    disableSortBy: true,
    accessor: 'creation_date',
    width: 120,
    Cell: ({ value }) => <DateColumn date={value} />,
  },
  {
    Header: 'Error',
    disableSortBy: true,
    accessor: 'error',
    width: 150,
    Cell: ({ value }) => (
      <Popup
        className="base-tooltip"
        content={value}
        trigger={
          <div className="retry-shipments-table__error-column">{value}</div>
        }
      />
    ),
  },
  {
    Header: 'Estado',
    disableSortBy: true,
    accessor: 'status',
    width: 160,
    Cell: ({ value }) => (
      <Label color={STATUSES[value]?.color || 'brown'}>
        {STATUSES[value]?.text || value}
      </Label>
    ),
  },
  {
    Header: 'Acciones',
    disableSortBy: true,
    textAlign: 'right',
    width: 80,
    Cell: ({ row }) => {
      return renderActions(row.original);
    },
  },
];
